import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericResponse } from '../model/genericResponse';
import { HttpClient } from '@angular/common/http';
import { CurrentUser } from '../model/current-user';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private http: HttpClient) { }

  login(data): Observable<GenericResponse<any>> {
    return this.http.post<GenericResponse<any>>(`user/login/online`, data);
  }

  signUpSubmit(data): Observable<GenericResponse<any>> {
    return this.http.post<GenericResponse<any>>(`signup/online`, data);
  }

  verifyPhoneSocialMediaOnline(phoneNumber): Observable<GenericResponse<any>> {
    return this.http.post<GenericResponse<any>>(`verifyphone/socialmedia/online`, phoneNumber);
  }

  verifyEmailSocialMediaOnline(email): Observable<GenericResponse<any>> {
    return this.http.post<GenericResponse<any>>(`verifyemail/socialmedia/online`, email);
  }

  socialMediaLogin(data): Observable<GenericResponse<CurrentUser>> {
    return this.http.post<GenericResponse<CurrentUser>>(`login/socialmedia/online`, data);
  }
  socialMediasignUp(data): Observable<GenericResponse<any>> {

    return this.http.post<GenericResponse<any>>(`signup/socialmedia/online`, data);


  }
  phoneNumberVerified(phoneNumber) {
    return this.http.get<GenericResponse<any>>(`user/__verified/phone/${phoneNumber}`);

  }

  resetCredentials(data): Observable<GenericResponse<any>> {
    return this.http.post<GenericResponse<any>>(`user/reset_credentials`, data);
  }
}
